'use strict';

angular.module('shiftTraderApp')
  .controller('RightBarScheduleCtrl', function ($scope, Session, WorkPeriods) {
    var wpRequestInProgress = false;
    $scope.me = Session.me;

    // loggedIn var describes whether there is a logged-in user currently using the site
    $scope.state = {
      loggedIn: Session.isLoggedIn()
    };

    $scope.$on('loginStateChanged', function(event, data) {
      $scope.state.loggedIn = data.state;
    });

    if (angular.isDefined($scope.me) && !_.isNull($scope.me) && !wpRequestInProgress) {
      console.log('RightBarSchedule... requesting WP.getByUserId');
      wpRequestInProgress = $scope.me.id;

      WorkPeriods.getByUserId($scope.me.id)
        .then(function(data) {
          wpRequestInProgress = false;
          // TODO: need to check for failure here
          $scope.myWorkPeriods = _.where(data, function(wp) {
            return wp.$isPublished();
          });
          setNextWorkPeriod();
        });
    }
    $scope.nextWorkPeriod = undefined;

    var calcNextWorkPeriod = function() {
      if (angular.isDefined($scope.myWorkPeriods)) {
        if ($scope.myWorkPeriods.length > 0) {
          var leastDiff = 999999999;
          var leastInd;
          var counter = 0;
          _.each($scope.myWorkPeriods, function(wp) {
            var wpst = moment(wp.start_time).unix() - moment().unix();
            if ( wpst < leastDiff && wpst > 0 ) {
              leastDiff = wpst;
              leastInd = counter;
            }
            counter++;
          });

          if (!angular.isDefined(leastInd)) {
            return false;
          } else {
            return $scope.myWorkPeriods[leastInd];
          }
        } else { return false; }

      } else { return undefined; }
    };

    var setNextWorkPeriod = function() {
      $scope.nextWorkPeriod = calcNextWorkPeriod();
      if (angular.isDefined($scope.nextWorkPeriod) && $scope.nextWorkPeriod !== false) {
        $scope.nextWorkPeriod._localStartTime = $scope.nextWorkPeriod.start_time.format('ddd h:mma, MMM D');
      }
    };

    $scope.$on('updatedSessionMe', function(event, isLoggedIn) {
      if (isLoggedIn) {
        $scope.me = Session.me;

        if (angular.isDefined($scope.me) && !_.isNull($scope.me) && !wpRequestInProgress) {
          wpRequestInProgress = $scope.me.id;
          WorkPeriods.getByUserId($scope.me.id)
            .then(function(data) {
              wpRequestInProgress = false;
              $scope.myWorkPeriods = _.where(data, function(wp) {
                return wp.$isPublished();
              });
              setNextWorkPeriod();

            });
        } else {
          $scope.nextWorkPeriod = undefined;
        }
      }
    });
  });
